<script setup lang="ts">
import { AccountSettings } from '@/components/account_settings';
</script>

<template>
  <div class="account-settings-container">
    <AccountSettings />
  </div>
</template>

<style scoped lang="scss">
.account-settings-container {
  height: 100%;
  overflow-y: scroll;
}
</style>
